export type PurchaseOrderTotalsInput = {
  /** Purchase orders */
  exchangeRate?: string | number | null;
  /** Supplier quotations */
  rate?: string | number | null;
  lineItems?: { lineTotal?: string | number | null }[];
  expenses?: { value?: string | number | null; vat?: string | number | null }[];
};

function toAmount(v: string | number | null | undefined): number {
  if (v == null || v === '') return 0;
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : 0;
}

/** Order-currency and USD totals (same rules as Detail: line totals + expense value+VAT; USD = × exchange rate). */
export function computePurchaseOrderTotals(order: PurchaseOrderTotalsInput): {
  itemsSum: number;
  expensesSum: number;
  grandTotal: number;
  grandTotalUsd: number | null;
} {
  const lines = order.lineItems ?? [];
  const expenses = order.expenses ?? [];
  let itemsSum = 0;
  for (const l of lines) {
    itemsSum += toAmount(l.lineTotal);
  }
  let expensesSum = 0;
  for (const e of expenses) {
    expensesSum += toAmount(e.value) + toAmount(e.vat);
  }
  const grandTotal = itemsSum + expensesSum;

  const rateRaw = order.exchangeRate ?? order.rate;
  const rate =
    rateRaw != null && rateRaw !== ''
      ? typeof rateRaw === 'number'
        ? rateRaw
        : Number(rateRaw)
      : NaN;
  if (!Number.isFinite(rate)) {
    return { itemsSum, expensesSum, grandTotal, grandTotalUsd: null };
  }
  let usd = 0;
  for (const l of lines) {
    usd += toAmount(l.lineTotal) * rate;
  }
  for (const e of expenses) {
    usd += (toAmount(e.value) + toAmount(e.vat)) * rate;
  }
  return { itemsSum, expensesSum, grandTotal, grandTotalUsd: usd };
}
